export default class GraphEvent {
    constructor(type: string, cells: any, dx: number, dy: number) {

    }
}